import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { EXPERIMENTS } from './experiments';
import { i18n } from './i18n';
import { createPrng } from './prob/prng';
import type { ExperimentKey, ProbContext } from './types';

const ORDER = Object.keys(EXPERIMENTS) as ExperimentKey[];
const params = new URLSearchParams(window.location.search);
const seedParam = params.get('seed');

bootstrapDemoShell({
  slug: 'probability',
  i18n,
  experiments: EXPERIMENTS,
  order: ORDER,
  eyebrowKey: 'app.eyebrow',
  helpLineKeys: ['hint.line1', 'hint.line2'],
  shotToExperiment: (id) => (ORDER.includes(id as ExperimentKey) ? (id as ExperimentKey) : null),
  extendContext: (base, { shotId }): ProbContext => ({
    ...base,
    prng: createPrng(seedParam ? Number(seedParam) : shotId !== null ? 12345 : undefined),
  }),
});
